/*
 * Legt den Schliessen-Button des Menue-Drawers deckungsgleich auf den Burger-Button.
 *
 * Der Drawer ist `position: fixed; top: 0`, der Burger sitzt dagegen in der Kopfzeile.
 * Deren Abstand nach oben haengt an der Ankuendigungsleiste und am Sticky-Zustand und
 * laesst sich in CSS nicht zuverlaessig ausdruecken. Darum wird das Rechteck des
 * <summary> gemessen und als Variablen an den Drawer geschrieben; das Ausrichten
 * selbst passiert in den Regeln zu `.menu-drawer > .menu-drawer__close-button`
 * in snippets/header-drawer.liquid.
 *
 * Gemessen wird beim Oeffnen (da ist der Header in genau dem Zustand, den man sieht)
 * sowie bei Groessenaenderungen des Summary-Elements.
 */

/** @param {HTMLElement} drawerRoot */
function alignCloseButton(drawerRoot) {
  const summary = drawerRoot.querySelector('summary.header__icon--summary');
  const panel = drawerRoot.querySelector('.menu-drawer');

  if (!(summary instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

  const rect = summary.getBoundingClientRect();

  // Beim Schliessen kann das Element bereits ausgeblendet sein - dann nichts anfassen,
  // sonst springt der Button auf 0/0, waehrend der Drawer noch heraus animiert.
  if (rect.width === 0 && rect.height === 0) return;

  // Bewusst ungerundet: der Header sitzt je nach Ankuendigungsleiste auf
  // Sub-Pixeln, und Runden schoebe das Icon sichtbar gegen den Burger.
  panel.style.setProperty('--menu-drawer-close-top', `${rect.top}px`);
  panel.style.setProperty('--menu-drawer-close-left', `${rect.left}px`);
  panel.style.setProperty('--menu-drawer-close-width', `${rect.width}px`);
  panel.style.setProperty('--menu-drawer-close-height', `${rect.height}px`);
}

/** @param {HTMLElement} drawerRoot */
function observe(drawerRoot) {
  const details = drawerRoot.querySelector('details.menu-drawer-container');
  const summary = drawerRoot.querySelector('summary.header__icon--summary');

  if (!(details instanceof HTMLDetailsElement) || !(summary instanceof HTMLElement)) return;

  // `toggle` feuert, bevor der Drawer eingeblendet ist - also vor dem ersten Frame messen.
  details.addEventListener('toggle', () => {
    if (details.open) alignCloseButton(drawerRoot);
  });

  // Fasst Viewport-Resize, Schriftwechsel und ein- oder ausklappende
  // Ankuendigungsleisten ab, ohne an jedem einzelnen Ausloeser zu haengen.
  if (typeof ResizeObserver === 'function') {
    const resizeObserver = new ResizeObserver(() => {
      if (details.open) alignCloseButton(drawerRoot);
    });
    resizeObserver.observe(summary);
    resizeObserver.observe(document.documentElement);
  }

  // Der Header ist sticky: beim Scrollen verschiebt sich der Burger vertikal.
  window.addEventListener(
    'scroll',
    () => {
      if (details.open) alignCloseButton(drawerRoot);
    },
    { passive: true }
  );

  if (details.open) alignCloseButton(drawerRoot);
}

function init() {
  document.querySelectorAll('header-drawer').forEach((drawerRoot) => {
    if (!(drawerRoot instanceof HTMLElement)) return;
    if (drawerRoot.dataset.closeAligned === 'true') return;

    drawerRoot.dataset.closeAligned = 'true';
    observe(drawerRoot);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

// Der Header wird ueber die Section Rendering API nachgeladen; dann sind die alten
// Knoten weg und die Listener muessen auf den neuen sitzen.
document.addEventListener('shopify:section:load', init);
